/*
  grillzen-cart.js — поведінка блоків кошика (розмітка у snippets/grillzen-cart-extras.liquid).

  Слухачі навішані на document через делегування: тема перемальовує шухляду
  після кожної зміни кошика, і прямі слухачі злітали б після першого кліку.

  Оновлення — рідним механізмом Horizon: запит з параметром sections
  (id секції з data-section-id у <cart-items-component>), а потім подія
  cart:update на document. Її ловлять cart-items-component (morphSection —
  перемальовує шухляду НЕ закриваючи її) і header-actions (лічильник у шапці).
  Раніше тут було window.location.reload() — шухляда закривалась після кожного кліку.
*/
(function () {
  'use strict';

  function component() {
    return document.querySelector('cart-items-component');
  }

  function sectionId() {
    var c = component();
    return c && c.dataset ? c.dataset.sectionId : null;
  }

  function notify(cart, sections) {
    var ev = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'grillzen-cart',
        data: { source: 'grillzen-cart', itemCount: cart.item_count, sections: sections || {} }
      }
    });
    document.dispatchEvent(ev);
  }

  function post(url, payload, btn) {
    var sid = sectionId();
    if (sid) { payload.sections = sid; payload.sections_url = window.location.pathname; }
    if (btn) btn.disabled = true;

    var sections = null;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.description) throw new Error(res.description);
        sections = res && res.sections ? res.sections : null;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (sid && sections && sections[sid]) {
          notify(cart, sections);            // тема сама перемалює шухляду
        } else {
          window.location.reload();          // запасний шлях, якщо секцію не віддали
        }
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        console.error('[grillzen-cart]', err);
      });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-gzc-add]');
    if (add) {
      e.preventDefault();
      post('/cart/add.js', { items: [{ id: Number(add.getAttribute('data-gzc-add')), quantity: 1 }] }, add);
      return;
    }

    // «дозбирай бандл»: кілька позицій одним запитом (Polishing Head + рукавиці)
    var many = e.target.closest && e.target.closest('[data-gzc-add-many]');
    if (many) {
      e.preventDefault();
      var list = [];
      try { list = JSON.parse(many.getAttribute('data-gzc-add-many')); } catch (err) {}
      if (list.length) post('/cart/add.js', { items: list }, many);
      return;
    }

    var sw = e.target.closest && e.target.closest('[data-gzc-warranty]');
    if (sw) {
      e.preventDefault();
      var id = sw.getAttribute('data-gzc-warranty');
      var on = sw.getAttribute('aria-checked') === 'true';
      sw.classList.toggle('is-on', !on);              // миттєвий відгук, далі перемалює тема
      sw.setAttribute('aria-checked', on ? 'false' : 'true');
      if (on) {
        post('/cart/change.js', { id: String(id), quantity: 0 }, sw);
      } else {
        post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }, sw);
      }
    }
  });

  // --- правила комплекту ---
  // 23.09.2026 (Андрій: «фіолетова щітка тільки комплектом, додаткову ще одну до одного гаджета не взяти»):
  // бандл = щітка (45276979134573) + Polishing Head (handle polishing-head) + рукавиці (R0).
  // На кожну зміну кошика (подія теми cart:update) і на завантаженні:
  //   немає щітки           → насадка й подарунки в 0 (окремо насадку купити не можна);
  //   насадок більше за щітки → рівно стільки, скільки щіток (одна на один пристрій);
  //   немає повного набору  → подарунки в 0; подарунків теж не більше, ніж щіток.
  // Старий варіант-бандл (50495398969453) сам по собі вже повний набір.
  var SINGLE_ID = 45276979134573, BUNDLE_ID = 50495398969453, HEAD_HANDLE = 'polishing-head';
  var WARRANTY_HANDLE = 'lifetime-warranty';
  var purging = false;
  function enforceBundleRules() {
    if (purging) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      function qty(list) { return list.reduce(function (n, i) { return n + i.quantity; }, 0); }
      var bundles = cart.items.filter(function (i) { return i.variant_id === BUNDLE_ID; });
      var singles = cart.items.filter(function (i) { return i.variant_id === SINGLE_ID; });
      var heads = cart.items.filter(function (i) { return i.handle === HEAD_HANDLE; });
      var gifts = cart.items.filter(function (i) { return i.original_price === 0; });
      var brushQty = qty(singles), bundleQty = qty(bundles);
      var setQty = bundleQty + Math.min(brushQty, qty(heads));   // скільки повних наборів у кошику
      var updates = {};

      // насадка: не більше, ніж щіток (і 0, якщо щіток нема)
      var headLeft = brushQty;
      heads.forEach(function (i) {
        var allow = Math.max(0, Math.min(i.quantity, headLeft));
        headLeft -= allow;
        if (allow !== i.quantity) updates[i.variant_id] = allow;
      });

      // гарантія — одна на замовлення (Андрій: «вона теж не може додаватися плюсом»)
      cart.items.forEach(function (i) {
        if (i.handle === WARRANTY_HANDLE && i.quantity > 1) updates[i.variant_id] = 1;
      });

      // подарунок: рівно стільки, скільки повних наборів
      var giftLeft = setQty;
      gifts.forEach(function (i) {
        var allow = Math.max(0, Math.min(i.quantity, giftLeft));
        giftLeft -= allow;
        if (allow !== i.quantity) updates[i.variant_id] = allow;
      });

      if (!Object.keys(updates).length) return;
      purging = true;
      post('/cart/update.js', { updates: updates }).then(function () { purging = false; });
    }).catch(function () { purging = false; });
  }
  document.addEventListener('cart:update', enforceBundleRules);
  // і один раз на завантаженні: кошик міг лишитись «кривим» з минулої сесії або після прямого посилання
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforceBundleRules);
  } else {
    enforceBundleRules();
  }

  // --- таймер резерву ---
  // Після нуля просто починається новий відлік: зникнення офера лякає покупця
  // сильніше, ніж допомагає (на цьому вже обпеклися з віджетом Vitals).
  setInterval(function () {
    var box = document.querySelector('[data-gzc-reserve]');
    if (!box) return;
    var out = box.querySelector('[data-gzc-clock]');
    if (!out) return;

    var mins = parseInt(box.getAttribute('data-minutes'), 10) || 5;
    var total = mins * 60;
    var KEY = 'gzc-reserve-deadline';

    var end = parseInt(sessionStorage.getItem(KEY), 10);
    if (!end || isNaN(end) || end <= Date.now()) {
      end = Date.now() + total * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (err) {}
    }

    var left = Math.max(0, Math.round((end - Date.now()) / 1000));
    var m = Math.floor(left / 60), s = left % 60;
    out.textContent = m + ':' + (s < 10 ? '0' + s : s);
  }, 1000);
})();
